import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Editor } from "react-draft-wysiwyg";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { dropdownIcon } from "../../../Shared/SVGs/Shared";
import { EditorState, convertFromHTML, ContentState } from "draft-js";

import draftToHtml from "draftjs-to-html";

import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import { defaultContent } from "./defaultTermsAndConditions";
import FormStepsModal from "./FormStepsModal";
import ImageSizeModal from "./ImageSizeModal";
import Cropper from "react-easy-crop";
import toolbarTerms from "../../../utility/toolbarTerms";

const infoIcon = require("@src/assets/images/vyrill/videos/info.png").default;
const CloseIcon = require("@src/assets/images/vyrill/videos/close.svg").default;

const FormStep3 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showImageSizeModal, setShowImageSizeModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [image, setImage] = useState("");
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const form = useSelector((state) => state.campaign_states.form);
  const terms_and_conditions_editor_state = useSelector(
    (state) => state.campaign_states.form.terms_and_conditions_editor_state
  );

  const handleImageTypeSelect = (option) => {
    dispatch(updateCampaignFields({ image_dimensions: option }));
    setDropdownOpen(false);
  };
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onSave = () => {
    if (croppedAreaPixels) {
      const canvas = document.createElement("canvas");
      const image = new Image();
      image.src = form?.campaign_banner_image_preview
        ? form?.campaign_banner_image_preview
        : require(`@src/assets/images/dropzoneimage.png`).default;
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas?.getContext("2d");

      ctx?.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );
      canvas?.toBlob((blob) => {
        if (blob) {
          const selectedImage = new File([blob], "cropped_image.jpeg", {
            type: blob.type,
          });
          const reader = new FileReader();
          reader.onloadend = () => {
            dispatch(
              updateCampaignFields({
                campaign_banner_image_file: selectedImage,
              })
            );
          };
          reader.readAsDataURL(selectedImage);
          const croppedImageURL = URL?.createObjectURL(blob);
          dispatch(
            updateCampaignFields({
              campaign_banner_image_preview: croppedImageURL,
            })
          );
        }
      }, "image/jpeg");
    }
    setCroppedImage(false);
  };

  const onCropChange = useCallback((crop) => {
    setCrop(crop);
  }, []);

  const onZoomChange = useCallback((zoom) => {
    setZoom(zoom);
  }, []);

  const onDrop = async (acceptedFiles) => {
    const selectedImage = acceptedFiles[0];
    const reader = new FileReader();

    if (selectedImage) {
      if (selectedImage.size > 9 * 1024 * 1024) {
        setShowImageSizeModal(true);
      } else {
        reader.onloadend = () => {
          dispatch(
            updateCampaignFields({
              // campaign_banner_image: reader.result,
              campaign_banner_image_file: selectedImage,
            })
          );
        };
        reader.readAsDataURL(selectedImage);
        dispatch(
          updateCampaignFields({
            campaign_banner_image_preview: URL.createObjectURL(selectedImage),
          })
        );
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCropSelect = () => {
    handleImageTypeSelect("Crop");
    setCroppedImage(true);
  };

  const cropMenu = (
    <DropdownMenu>
      <DropdownItem
        onClick={() => {
          handleImageTypeSelect("Fill");
          setCroppedImage(false);
        }}
      >
        <div>Fill</div>
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          handleImageTypeSelect("Fit");
          setCroppedImage(false);
        }}
      >
        <div>Fit</div>
      </DropdownItem>
      <DropdownItem onClick={handleCropSelect}>
        <div>Crop</div>
      </DropdownItem>
    </DropdownMenu>
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const uploadedImage = (
    <div className="step3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="title">Upload Campaign Image</div>
        <div>
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
            style={{ zIndex: "2" }}
          >
            <DropdownToggle>
              <div className="d-flex align-items-center justify-content-between">
                <p className="">
                  {form?.image_dimensions ? (
                    form?.image_dimensions
                  ) : (
                    <span>Fit</span>
                  )}
                </p>
                <p>{dropdownIcon}</p>
              </div>
            </DropdownToggle>
            {cropMenu}
          </Dropdown>
        </div>
      </div>
      <div className="drag-and-crop">
        {croppedImage ? (
          <Cropper
            image={
              form?.campaign_banner_image_preview
                ? form?.campaign_banner_image_preview
                : require(`@src/assets/images/dropzoneimage.png`).default
            }
            crop={crop}
            zoom={zoom}
            aspect={1.628 / 1}
            // aspect={4/3}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={onZoomChange}
          />
        ) : (
          <div className="drag-and-drop" {...getRootProps()}>
            {<input {...getInputProps()} />}
            <img
              src={
                form?.campaign_banner_image_preview
                  ? form?.campaign_banner_image_preview
                  : require(`@src/assets/images/dropzoneimage.png`).default
              }
              alt="Selected"
              style={{
                width: "100%",
                height: "100%",
                objectFit:
                  form?.image_dimensions === "Fill"
                    ? "cover"
                    : form?.image_dimensions === "Fit"
                    ? "contain"
                    : "contain",
                borderRadius: "10px",
              }}
            />
          </div>
        )}
      </div>
      <div onClick={onSave} role="button">
        {croppedImage && <div className="done">Save</div>}
      </div>
      <div className="image-formats">
        Format: JPG, PNG, TIF, GIF
        <span className="ms-1 me-1">
          Preferred Dimension: W 1024 pixel, H 768 pixel
        </span>
        Resolution: 300dpi <br />
        <span className="me-2">Image size limit - 9 mb</span> *If no image is
        uploaded, the default image will be the campaign image.
      </div>
    </div>
  );

  useEffect(() => {
    const blocksFromHTML = convertFromHTML(defaultContent);
    const state = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    dispatch(
      updateCampaignFields({
        terms_and_conditions_editor_state: EditorState.createWithContent(state),
        terms_and_conditions: defaultContent,
      })
    );
  }, []);

  const handleTermsContentState = (contentState) => {
    dispatch(
      updateCampaignFields({ terms_and_conditions: draftToHtml(contentState) })
    );
  };
  const handleTermsEditorState = (editorState) => {
    dispatch(
      updateCampaignFields({ terms_and_conditions_editor_state: editorState })
    );
  };

  const handleNext = async () => {
    dispatch(updateCampaignState({ activeStep: activeStep + 1 }));
  };

  const tooltipStyle = { display: hover ? "block" : "none" };
  const [hover, setHover] = useState(false);
  const toggleVyrillTooltip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHover(!hover);
  };

  return (
    <div className="form-step-3">
      <ImageSizeModal
        open={showImageSizeModal}
        toggle={() => setShowImageSizeModal(false)}
      />
      <FormStepsModal
        step={3}
        content={
          "Upload a vibrant, visually stimulating image that resonates with your audience and captures their attention."
        }
        style={{ position: "relative", top: "220px", left: "130px" }}
      />
      {uploadedImage}

      <div className="mt-4 mb-3">
        <span className="title">Terms and Conditions</span>
        <span>
          <img
            style={{ marginLeft: "10px", marginBottom: "3px" }}
            role="button"
            width={13}
            src={infoIcon}
            onClick={toggleVyrillTooltip}
          />
        </span>
        {hover && (
          <div style={{ position: "absolute" }}>
            <div className="tooltip-vyrill-data-logo">
              <img
                role="button"
                onClick={toggleVyrillTooltip}
                className="opacity-100 cross"
                src={CloseIcon}
                style={{ width: "14px" }}
              />
              You have the option to utilize the default Vyrill Terms &
              Conditions or customize your own.
            </div>
          </div>
        )}
      </div>

      <Editor
        editorState={terms_and_conditions_editor_state}
        toolbarClassName="editor-toolbar"
        wrapperClassName="editor-wrapper-step-3"
        editorClassName="editor-text-area-style-terms"
        onEditorStateChange={handleTermsEditorState}
        onContentStateChange={handleTermsContentState}
        toolbar={toolbarTerms}
        // localization={localization}
        placeholder="Terms and Conditions"
        // spellCheck
        id="TermsandConditions"
        stripPastedStyles
      />
      <div className="center mt-5 mb-5">
        <Button
          className="campaign-button"
          size="lg"
          color={`${croppedImage} ? secondary : primary`}
          disabled={croppedImage}
          style={{ background: croppedImage ? "#C4C4C4" : "" }}
          onClick={() => handleNext()}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default FormStep3;
